export const fundingRoundsFiltersMapping = {
  'q[money_raised_usd_gt]': 'q[money_raised_usd_gt]',
  'q[money_raised_usd_lt]': 'q[money_raised_usd_lt]',
  'q[funding_type_matches_any][]': 'funding_type'
};
